const contents = {
    en:{
        scene_img_0: require('@/files/scene/S00.jpg'),
        scene_img_1: require('@/files/scene/S01.jpg'),
        scene_img_2: require('@/files/scene/S02.jpg'),
        scene_img_3: require('@/files/scene/S03.jpg'),
        scene_img_4: require('@/files/scene/S04.jpg'),
        scene_img_5: require('@/files/scene/S05.jpg'),
        scene_img_6: require('@/files/scene/S06.jpg'),
        scene_img_7: require('@/files/scene/S07.jpg'),
        scene_img_8: require('@/files/scene/S08.jpg'),
        scene_img_9: require('@/files/scene/S09.jpg'),
        scene_img_10: require('@/files/scene/S10.jpg'),
        scene_img_11: require('@/files/scene/S11.jpg'),
        scene_img_12: require('@/files/scene/S12.jpg'),
        scene_img_13: require('@/files/scene/S13.jpg'),
        scene_img_14: require('@/files/scene/S14.jpg'),

        move_img_common: require('@/files/scene/Arrow.png'),
        click_img_run: require('@/files/scene/runClick.png'),
        click_img_shop: require('@/files/scene/shopClick.svg').default,
        click_img_video: require('@/files/scene/videoClick.svg').default,
        click_img_img: require('@/files/scene/videoClick.svg').default,
    },
    ch:{
      scene_img_0: require('@/files/scene/S00.jpg'),
      scene_img_1: require('@/files/scene/S01.jpg'),
      scene_img_2: require('@/files/scene/S02.jpg'),
      scene_img_3: require('@/files/scene/S03.jpg'),
      scene_img_4: require('@/files/scene/S04.jpg'),
      scene_img_5: require('@/files/scene/S05.jpg'),
      scene_img_6: require('@/files/scene/S06.jpg'),
      scene_img_7: require('@/files/scene/S07.jpg'),
      scene_img_8: require('@/files/scene/S08.jpg'),
      scene_img_9: require('@/files/scene/S09.jpg'),
      scene_img_10: require('@/files/scene/S10.jpg'),
      scene_img_11: require('@/files/scene/S11.jpg'),
      scene_img_12: require('@/files/scene/S12.jpg'),
      scene_img_13: require('@/files/scene/S13.jpg'),
      scene_img_14: require('@/files/scene/S14.jpg'),

      move_img_common: require('@/files/scene/Arrow.png'),
      click_img_run: require('@/files/scene/runClick.png'),
      click_img_shop: require('@/files/scene/shopClick.svg').default,
      click_img_video: require('@/files/scene/videoClick.svg').default,
      click_img_img: require('@/files/scene/videoClick.svg').default,
    }
}

export function getContent(code, key){
    return contents[code][key]
}

// import { getContent } from './content.js'
// { getContent(language, 'xxxxxxxx') }
// getContent(language, 'xxxxxxxx')


